export default {"src":"/_next/static/media/ProcessLine.cf9d7b71.svg","height":16,"width":82};